/**
 * freeBusyGrid.ts — map a barrister's opaque free/busy slots onto the Master Diary hour columns.
 *
 * Calendar times are stored as wall-clock-in-UTC (`${date}T${time}:00Z`) and read back in UTC
 * everywhere (see calendarApi mapCalEvent). This helper MUST use the same UTC convention: building
 * the hour cells with LOCAL time (`Date#setHours`) shifted every busy slot by the browser's offset,
 * so a 12:10 event painted the 17:00 column for a clerk in IST — the barrister looked free at noon
 * and busy at 5pm. Pure + timezone-independent so it can be unit-tested to guarantee that never
 * regresses.
 */
export function busyHourColumns(
  slots: { start: string; end: string }[],
  dateKey: string,
  hourLabels: string[],
): Set<number> {
  const hours = new Set<number>();
  for (const s of slots) {
    const slotStart = Date.parse(s.start);
    const slotEnd = Date.parse(s.end);
    if (Number.isNaN(slotStart) || Number.isNaN(slotEnd)) continue;
    for (let h = 0; h < hourLabels.length; h++) {
      const cellStart = Date.parse(`${dateKey}T${hourLabels[h]}:00:00Z`);
      const cellEnd = cellStart + 3_600_000;
      if (slotStart < cellEnd && slotEnd > cellStart) hours.add(h);
    }
  }
  return hours;
}
